var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 40,
    viewBox: "0 0 246 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.442 0.367188C61.442 3.01326 63.0548 5.27876 65.353 6.24138C66.8403 6.8682 67.8169 8.30988 67.8169 9.92618V39.6329H74.1874V0.367188H61.442Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.106 33.7587C178.619 33.1319 177.642 31.6902 177.642 30.0739V0.367188H171.272V39.6329H184.017C184.017 36.9868 182.404 34.7213 180.106 33.7587Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2889 39.6329V26.8995C37.7388 26.8995 36.3321 27.4547 35.2345 28.377C33.9802 29.4336 32.242 29.6933 30.7815 28.9501L13.153 20.0045L30.786 11.0589C32.2509 10.3157 33.9846 10.5753 35.239 11.632C36.3366 12.5543 37.7478 13.1095 39.2933 13.1095V0.362671L0 20L39.2889 39.6329Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.455 19.9955L206.166 0.362671V13.0961C207.716 13.0961 209.122 12.5364 210.22 11.6185C211.474 10.5619 213.213 10.3022 214.673 11.0455L232.301 19.9911L214.673 28.9367C213.208 29.6799 211.474 29.4202 210.22 28.3636C209.122 27.4412 207.711 26.8861 206.166 26.8861V39.6374L245.455 20V19.9955Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.369 20H122.727C122.727 23.5192 125.581 26.3667 129.102 26.3667H134.72C132.426 30.6694 127.946 33.6289 122.732 33.6289C115.201 33.6289 109.095 27.5263 109.095 20C109.095 12.4737 115.201 6.37121 122.732 6.37121C126.499 6.37121 129.909 7.89796 132.377 10.3649L136.884 5.8608C133.264 2.24316 128.26 0.0045166 122.736 0.0045166C111.684 0.0045166 102.724 8.95907 102.724 20.0045C102.724 31.05 111.684 40.0045 122.736 40.0045C133.788 40.0045 142.748 31.05 142.748 20.0045H136.378L136.369 20Z",
    fill: "#050505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_1463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245.455,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.191dc545a0213d2f47ed8119fc8cf0b2.svg";
export { ForwardRef as ReactComponent };